module.exports = __webpack_public_path__ + "static/media/sospiroerbapura.30341547.png";